//import files to bundle with rollup
import { load } from '@shopify/theme-sections';
import './sections/product';


load('*')
